export const urlPaginaMieiPiani = '#/pianidivalore?CodiceUfficio=';

export function calcolaUrlPaginaMieiPiani(codiceUfficio) {
  return `${window.UrlMyContratti}${urlPaginaMieiPiani + codiceUfficio}&utm_source=support`;
}

export function vaiPaginaMieiPiani(codiceUfficio) {
  window.open(calcolaUrlPaginaMieiPiani(codiceUfficio), '_blank');
}
